import { Outlet } from "react-router-dom";

export default function ShowLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
